import { Component } from '@angular/core';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-cards-doggoverse',
  imports: [
    RouterLink
  ],
  templateUrl: './cards-doggoverse.component.html',
  styleUrl: './cards-doggoverse.component.scss'
})
export class CardsDoggoverseComponent {

}
